module.exports = __webpack_public_path__ + "media/svg-new/icon-chev-left-468ea7d2.svg";